// Winkelteksten : pagina Shop + galerij « het spel in het echt ».
// Vertaling van fr/shop.js — exact dezelfde sleutels.
// Productteksten (name, description, features van de packs) staan hier NIET :
// die komen uit de database via tp()/tpList() (zie LanguageContext).
export default {
  'shop.seo.titre': 'Shop - Gender reveal puzzels',
  'shop.seo.description':
    "Twee Joyful Reveal-packs om het geslacht van de baby met de familie te onthullen. Levering in België, Nederland, Frankrijk, Luxemburg, Duitsland en Spanje.",

  'shop.page.chargement': 'De shop wordt geladen...',

  // Gestructureerde data schema.org (CollectionPage) in de <head>.
  'shop.schema.nom': 'Mirum Games shop',
  'shop.schema.description': 'Ontdek al onze Joyful Reveal packs',

  'shop.entete.badge': '🛍️ Onze shop',
  'shop.entete.titre': 'Joyful Reveal - Beertjes',
  'shop.entete.texte':
    'Kies het pack dat past bij uw magische moment. Elke puzzel is een speciale creatie voor uw familie.',

  // Keuzehulp : de zin is opgeknipt omdat « Essentiel » en « Premium » in de
  // JSX tussen <strong> staan. seg1+seg2+seg3+seg4+seg5 = de hele zin ; de
  // spaties aan het begin en het einde van de segmenten tellen mee.
  'shop.aide.titre': 'Twee packs, één spel',
  'shop.aide.seg1': 'Het ',
  'shop.aide.seg2': 'Essentiel',
  'shop.aide.seg3': ' als u uw vragen en uw teams zelf voorbereidt. Het ',
  'shop.aide.seg4': 'Premium',
  'shop.aide.seg5':
    ' als u alles kant-en-klaar wilt ontvangen: de katoenen zakjes, de gedrukte vragenlijst en de herinneringsenvelop.',

  // Terugval voor producten : alleen als de database geen description en geen
  // features levert (zou niet mogen gebeuren) — dit zijn geen packs.*-sleutels.
  'shop.produit.descriptionRepli':
    'Ontdek dit Joyful Reveal pack voor een onvergetelijke gender reveal party!',
  'shop.produit.repliDuo1': '2 speldozen',
  'shop.produit.repliDuo2': 'Voordelig pack',
  'shop.produit.repliDuo3': 'Ideaal voor 2 feestjes',
  'shop.produit.repliFamille1': '3 complete kits',
  'shop.produit.repliFamille2': 'Beste prijs-kwaliteitverhouding',
  'shop.produit.repliFamille3': 'Ideaal voor grote families',
  'shop.produit.repliPremium1': 'Compleet spel',
  'shop.produit.repliPremium2': 'Accessoires inbegrepen',
  'shop.produit.repliPremium3': 'Premiumkwaliteit',
  'shop.produit.repliMixte1': 'Versie meisje + jongen',
  'shop.produit.repliMixte2': 'Ideaal voor een tweeling',
  'shop.produit.repliMixte3': 'Compleet pack',
  'shop.produit.repliDefaut1': 'Gender reveal speldoos',
  'shop.produit.repliDefaut2': 'Ambachtelijk gemaakt',
  'shop.produit.repliDefaut3': 'Snelle levering',

  // Naam van het artikel zoals het in het winkelmandje komt.
  'shop.panier.nomArticle': 'Joyful Reveal - Beertjes - {nom}',
  'shop.panier.suffixeGarcon': ' (Jongen)',
  'shop.panier.suffixeFille': ' (Meisje)',

  'shop.grille.altPhoto': '{nom} — Joyful Reveal, gender reveal spel, productfoto',
  'shop.grille.rupture': '❌ UITVERKOCHT',
  'shop.grille.bientotRetour': 'Binnenkort weer beschikbaar',
  'shop.grille.enStock': 'Op voorraad',
  'shop.grille.voirPlus': 'Meer tonen',
  'shop.grille.autresCaracteristiques': '+{n} meer',
  'shop.grille.epuise': 'Uitverkocht',
  'shop.grille.ajoute': '✓ Toegevoegd!',
  'shop.grille.ajouter': '🛒 Toevoegen',
  'shop.grille.versPanier': '→ Winkelmandje',
  'shop.grille.ficheComplete': '📋 Bekijk de volledige productpagina',

  'shop.vide.titre': 'Geen pack gevonden',
  'shop.vide.texte': 'Probeer een andere filter',

  'shop.pourquoi.titre': 'Waarom kiezen voor Joyful Reveal?',
  'shop.pourquoi.emballageTitre': 'Premium verpakking',
  'shop.pourquoi.emballageTexte':
    'Elke puzzel komt in een elegante cadeauverpakking, klaar om weg te geven of samen te openen.',
  'shop.pourquoi.jeuTitre': 'Interactief spel',
  'shop.pourquoi.jeuTexte':
    'Een uniek concept dat de onthulling verandert in een spelmoment waar iedereen aan meedoet, met leuke vragen en antwoorden.',
  'shop.pourquoi.assemblageTitre': 'Makkelijk in elkaar te zetten',
  'shop.pourquoi.assemblageTexte':
    'Een puzzel die u tijdens het vraag-en-antwoordspel makkelijk samen met de familie in elkaar zet.',
  'shop.pourquoi.momentTitre': 'Magisch moment',
  'shop.pourquoi.momentTexte':
    'Creëer een onvergetelijke herinnering door samen met de familie het geslacht van de baby te onthullen.',
  'shop.pourquoi.expeditionTitre': 'Verzonden vanuit België',
  'shop.pourquoi.expeditionTexte':
    'Binnen 1 tot 2 werkdagen onderweg naar België, Frankrijk en Luxemburg. Stevige verpakking.',
  'shop.pourquoi.retractationTitre': '14 dagen bedenktijd',
  'shop.pourquoi.retractationTexte':
    'Herroepingsrecht van 14 dagen na ontvangst, zoals de Europese wetgeving over online aankopen het voorziet.',

  'shop.cta.titre': 'Klaar voor de magische onthulling?',
  'shop.cta.texte': 'Kies uw pack en creëer een onvergetelijk moment met uw familie',
  'shop.cta.bouton': '🛒 Ontdek de packs',

  'shop.modale.titre': 'Het is voor...',
  'shop.modale.sousTitre': 'Kies het geslacht voor uw puzzel',
  'shop.modale.garcon': 'Jongen',
  'shop.modale.fille': 'Meisje',
  'shop.modale.annuler': 'Annuleren',

  'shop.galerie.titre': 'Het spel in het echt',
  'shop.galerie.sousTitre':
    'Foto’s van het product zoals u het ontvangt — geen verrassingen achteraf.',
  'shop.galerie.agrandir': 'Foto vergroten: {titre}',
  'shop.galerie.fermer': 'Sluiten',
  'shop.galerie.boiteRectoTitre': 'De doos',
  'shop.galerie.boiteRectoLegende': 'Het spel Joyful Reveal, klaar om cadeau te geven.',
  'shop.galerie.boiteRectoAlt':
    'Doos van het spel Joyful Reveal: twee beertjes, puzzelstukje om te krassen “GIRL of BOY?”',
  'shop.galerie.contenuTitre': 'Wat u ontvangt',
  'shop.galerie.contenuLegende':
    'De doos, de vragenlijst als herinnering en de twee katoenen teamzakjes.',
  'shop.galerie.contenuAlt':
    'Volledige inhoud van het spel Joyful Reveal: de doos, de vragenlijst als herinnering en de twee katoenen zakjes',
  'shop.galerie.pochonsTitre': 'De twee teams',
  'shop.galerie.pochonsLegende': 'Twee katoenen zakjes voor Team 1 en Team 2.',
  'shop.galerie.pochonsAlt':
    'De twee katoenen zakjes van het spel, met het label Team 1 en Team 2, versierd met beertjes',
  'shop.galerie.boiteVersoTitre': 'Hoe het spel werkt',
  'shop.galerie.boiteVersoLegende': 'De 4 stappen van het spel, 2 tot 10 spelers, ongeveer 20 minuten.',
  'shop.galerie.boiteVersoAlt':
    'Achterkant van de doos Joyful Reveal met de 4 stappen van het spel, voor 2 tot 10 spelers, 20 minuten',
};
